import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminExportTsd = () => {
  return useMutation({
    mutationFn: async (tsdId: string) => {
      const response = await request({
        path: `admin/export-tsd/${tsdId}`,
        method: 'GET',
        authenticate: true,
        responseType: 'blob',
      });

      return { data: response, tsdId };
    },
    onSuccess: ({ data, tsdId }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', `tsd-${tsdId}.zip`);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      toast.success('TSD export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting TSD');
    },
  });
};
